import { useEffect, useState } from 'react';

import getPaymentMethods from '@/shared/api/orders/payments/getPaymentMethods';
import getPaymentStatuses from '@/shared/api/orders/payments/getPaymentStatuses';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';

const usePaymentMethodsAndStatuses = () => {
  const redirectLogin = useRedirectLogin();

  const [paymentDetails, setPaymentDetails] = useState<{
    methods: Record<string, string>;
    statuses: Record<string, string>;
  }>({
    methods: {},
    statuses: {},
  });

  useEffect(() => {
    const fetchMethodsAndStatuses = async () => {
      const responsePaymentStatuses = await getPaymentStatuses({
        onUnauthorized: redirectLogin,
      });
      const responsePaymentMethods = await getPaymentMethods({
        onUnauthorized: redirectLogin,
      });

      await Promise.allSettled([
        responsePaymentStatuses,
        responsePaymentMethods,
      ]).then((responses) => {
        const [statuses, methods] = responses;

        if (statuses.status === 'fulfilled' && methods.status === 'fulfilled') {
          setPaymentDetails({
            statuses: statuses.value.data.reduce(
              (acc, curr) => ({ ...acc, [curr]: curr }),
              {},
            ),
            methods: methods.value.data.reduce(
              (acc, curr) => ({ ...acc, [curr]: curr }),
              {},
            ),
          });
        }
      });
    };

    void fetchMethodsAndStatuses();
  }, [redirectLogin]);

  return paymentDetails;
};

export default usePaymentMethodsAndStatuses;
